<template>
  <v-app>
    

    <v-navigation-drawer
              v-model="drawer"
              :mini-variant.sync="mini"
              app
              clipped
              expand-on-hover
            >
              <v-list-item class="px-2">
                <v-list-item-avatar>
                  <v-img src="https://randomuser.me/api/portraits/men/85.jpg"></v-img>
                </v-list-item-avatar>

                <v-list-item-title>James Brett</v-list-item-title>

                
              </v-list-item>

              <v-divider></v-divider>

              <v-list dense>
                <v-list-item
                  link
                >
                  <v-list-item-icon>
                    <v-icon>mdi-home-city</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Home</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-navigation-drawer>

      <v-app-bar
      app
      color="white"
      dark
      clipped-left="true"
    >
      <div class="d-flex align-center font-weight-bold black--text">
        ENNEAGRAM EXPLORER
      </div>

      <v-spacer></v-spacer>
      
      <div class="caption">
        v0.1
      </div>
    </v-app-bar>


    <v-content>
      <v-row height="100%">

        <v-col class="pa-0" cols="5">
          <EnneagramSymbol @type-clicked="typeClicked"/>
        </v-col>

        <v-col class="pa-0" cols="7">
          <EnneagramTypeDetail :typeNumber="typeNumber" />
        </v-col>

      </v-row>
    </v-content>
  </v-app>
</template>

<script>
import EnneagramSymbol from './components/EnneagramSymbol';
import EnneagramTypeDetail from './components/EnneagramTypeDetail';

export default {
  name: 'App',

  methods: {

    typeClicked: function (tNumber) {
      this.typeNumber = tNumber
    },

  },

  components: {
    EnneagramSymbol,
    EnneagramTypeDetail
  },

  data: () => ({
    typeNumber : 1,
    drawer: true,
    mini: true,
  }),
};
</script>

<style scoped>

.leftMenu {
  float: left;
}

</style>